import { useTranslation } from "react-i18next";
import { LANGUAGES, setDeviceLanguage, type Language } from "../i18n";

export function LanguageSwitch() {
  const { t, i18n } = useTranslation();
  return (
    <label className="flex items-center gap-1.5 text-[12.5px] text-neutral-500">
      <span className="sr-only">{t("language.label")}</span>
      <select
        aria-label={t("language.label")}
        className="kss-control kss-field bg-transparent px-2 py-1 text-xs text-neutral-900 dark:text-neutral-100"
        value={i18n.language}
        onChange={(e) => setDeviceLanguage(e.target.value as Language)}
      >
        {LANGUAGES.map((l) => (
          <option key={l} value={l}>
            {t(`language.${l}`)}
          </option>
        ))}
      </select>
    </label>
  );
}
